import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		width: '100%',
	},
	filtersRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	filterGroup: {
		display: 'flex',
		alignItems: 'center',
		flexShrink: 1,
		minWidth: 0,
	},
	clearFiltersContainer: {
		flexShrink: 0,
	},
	comboBoxRightAutocompleteResponsive: {
		marginLeft: -1,
		width: 300,
		minWidth: 200,
		flexShrink: 1,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
	},
});
